import Form from './form.connect'

export default Form
